export const LOCATION_PREFIX = '/new-register';

export const PAGES = {
    errorPage: {
        label: 'errorPage',
        link: '/500',
        title: 'errorPage.title',
    },
    landing: {
        label: 'landing',
        link: '/',
        title: 'landing.title',
    },
    notFound: {
        label: 'notFound',
        link: '/404',
        title: 'notFound.title',
    },
};
